import styled, { css } from 'styled-components'
import { setInputCommonStyles } from 'styles/mixins'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

const _getInputPadding = ({
  $isSearchType,
  $isStaticView
}: {
  $isSearchType: boolean
  $isStaticView: boolean
}) => {
  if ($isSearchType) {
    if ($isStaticView) {
      return css`
        padding-inline: 10px 70px;
      `
    }
    return css`
      padding-inline: 40px 24px;
    `
  }
  return css`
    padding-inline: 12px;
  `
}

export const Input = styled.input<{
  $isError?: boolean
  $isWarning?: boolean
  $isSearchType: boolean
  $isStaticView: boolean
}>`
  width: 100%;
  border-radius: ${RADII.field};
  font-weight: 500;
  line-height: 17px;
  height: 40px;

  background-color: ${COLORS.surface};
  font-size: ${props => (props.$isSearchType ? '12px' : '14px')};

  ${_getInputPadding}

  &::placeholder {
    color: ${COLORS.placeholder};
    font-size: 12px;
  }
  color: ${COLORS.textPrimary};

  ${props =>
    setInputCommonStyles(
      props.$isError,
      props.$isWarning,
      false,
      COLORS.borderColor,
      COLORS.secondarySemiLight,
      COLORS.primaryDark,
      COLORS.primaryLight,
      COLORS.white
    )}

  /* Hide browser default search cancel button when type is search */
&[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
  }

  &[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
    appearance: none;
  }

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    min-width: 50px;
    width: 100%;
  }
`

export const InputBlock = styled.div`
  position: relative;
  width: 100%;

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
  }
`
